var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-8"},[_c('h1',[_vm._v("hello from sidebar")]),_vm._v(" "+_vm._s(_vm.element)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }